import React from 'react'
import injectSheet from 'react-jss'
import pure from 'recompose/pure'

const DEFAULT_FADETIME = 500

const styleSheet = {
    fadeContainer: {
        transition: ({ fadeTime = DEFAULT_FADETIME }) => {
            if (typeof fadeTime == 'number' && fadeTime == 0) {
                return 'none'
            }

            const time = typeof fadeTime == 'number' ? fadeTime + 'ms' : fadeTime

            return `visibility ${time}, opacity ${time}`
        },
        visibility: ({ isShown }) => (isShown ? 'visible' : 'hidden'),
        opacity: ({ isShown }) => (isShown ? 1 : 0),
    },
}

/**
 * Simple HOC which fades components in and out;
 * accepts "isShown" and "fadeTime"(optional) as props
 *
 * (Non-pure base component)
 */
export const componentFaderBase = WrappedComponent => {
    const content = ({ classes, ...propsWOClasses }) => (
        <div className={classes.fadeContainer}>
            <WrappedComponent {...propsWOClasses} faderClasses={classes} />
        </div>
    )
    content.displayName = 'ComponentFader'

    const containerHOC = injectSheet(styleSheet)(content)
    containerHOC.displayName = 'ComponentFaderContainer'
    return containerHOC
}

/**
 * Simple HOC which fades components in and out;
 * accepts "isShown" and "fadeTime"(optional) as props
 *
 * (as Pure component)
 **/
export function componentFader(WrappedComponent) {
    const component = componentFaderBase(WrappedComponent)
    component.displayName = 'PureComponentFader'
    return pure(component)
}
componentFader.displayName = 'ComponentFader'

export default componentFader
